import { render, staticRenderFns } from "./index_header.vue?vue&type=template&id=3c5b17aa&"
import script from "./index_header.vue?vue&type=script&lang=js&"
export * from "./index_header.vue?vue&type=script&lang=js&"
import style0 from "./index_header.vue?vue&type=style&index=0&id=3c5b17aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports